<template>
  <div class="card p-3 mb-4">
    <div class="row g-3">

      <!-- Argomenti -->
      <div class="col-md-3">
        <label class="form-label fw-bold">Argomenti</label>
        <div class="dropdown">
          <button class="btn btn-outline-primary dropdown-toggle w-100 text-start" type="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            {{ selectedTopicsLabel }}
          </button>
          <ul class="dropdown-menu" style="max-height: 300px; overflow-y: auto;">
            <li class="px-3 py-2">
              <input type="text" class="form-control" v-model="topicSearch" placeholder="Cerca argomento..." />
            </li>
            <li v-for="topic in filteredTopics" :key="topic.id" class="form-check px-3 py-1">
              <input class="form-check-input" type="checkbox" :value="topic.id" v-model="localSelectedTopics" />
              <label class="form-check-label ms-2">{{ topic.title }}</label>
            </li>
          </ul>
        </div>
      </div>
      <!-- Legislazione -->
      <div class="col-md-3">
        <label class="form-label fw-bold">Legislazione</label>
        <div class="dropdown">
          <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start" data-bs-toggle="dropdown">
            {{ selectedLegislationLabel }}
          </button>
          <ul class="dropdown-menu p-2" style="max-height:250px; overflow-y:auto;">
            <!-- Opzione per tutte -->
            <li class="form-check">
              <input class="form-check-input" type="radio" :value="null" v-model="localSelectedLegislation" />
              <label class="form-check-label ms-2">Seleziona Legislazione</label>
            </li>

            <li v-for="leg in allLegislations" :key="leg.id" class="form-check">
              <input class="form-check-input" type="radio" :value="leg.id" v-model="localSelectedLegislation" />
              <label class="form-check-label ms-2">{{ leg.title }}</label>
            </li>
          </ul>
        </div>
      </div>

      <!-- Articoli -->
      <div class="col-md-3">
        <label class="form-label fw-bold">Articoli</label>
        <div class="dropdown">
          <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start" data-bs-toggle="dropdown">
            <span class="truncate-text">{{ selectedArticlesLabel }}</span>
          </button>
          <ul class="dropdown-menu p-2" style="max-height:300px; overflow-y:auto;">
            <li class="p-2">
              <input type="text" class="form-control" v-model="articleSearch" placeholder="Cerca articolo..." />
            </li>
            <li v-for="art in filteredArticles" :key="art.id" class="form-check">
              <input class="form-check-input" type="checkbox" :value="art.id" v-model="localSelectedArticles" />
              <label class="form-check-label ms-2">{{ art.title }}</label>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <!-- Filtri gestore -->
    <div v-if="isGestore" class="row g-3 mt-3">
      <!-- Filtri testuali -->
      <div class="col-md-3">
        <label class="form-label fw-bold">ID Quesito</label>
        <input type="text" class="form-control" v-model="filterId" placeholder="ID Quesito" />
      </div>

      <div class="col-md-3">
        <label class="form-label fw-bold">Oggetto</label>
        <input type="text" class="form-control" v-model="filterObject" placeholder="Oggetto" />
      </div>

      <div class="col-md-3">
        <label class="form-label fw-bold">Stazione Appaltante</label>
        <input type="text" class="form-control" v-model="filterOrganization" placeholder="Stazione Appaltante" />
      </div>

      <div class="col-md-3">
        <label class="form-label fw-bold">Testo Quesito</label>
        <input type="text" class="form-control" v-model="filterText" placeholder="Testo Quesito" />
      </div>

      <!-- Regione come checkbox multiplo -->
      <div class="col-md-3">
        <label class="form-label fw-bold">Regione</label>
        <div class="dropdown">
          <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start" data-bs-toggle="dropdown">
            {{ selectedRegionsLabel }}
          </button>
          <ul class="dropdown-menu p-2" style="max-height:250px; overflow-y:auto;">
            <li v-for="r in allRegions" :key="r.id" class="form-check">
              <input class="form-check-input" type="checkbox" :value="r.id" v-model="filterRegion" />
              <label class="form-check-label ms-2">{{ r.name }}</label>
            </li>
          </ul>
        </div>
      </div>

      <!-- Anno -->
      <div class="col-md-3">
        <label class="form-label fw-bold">Anno</label>
        <div class="dropdown">
          <button class="btn btn-light border text-dark dropdown-toggle w-100 text-start" data-bs-toggle="dropdown">
            {{ localSelectedYearLabel }}
          </button>
          <ul class="dropdown-menu p-2" style="max-height:200px; overflow-y:auto;">
            <li v-for="y in allYears" :key="y.id" class="form-check">
              <input class="form-check-input" type="checkbox" :value="y" v-model="filterYear" />
              <label class="form-check-label ms-2">{{ y }}</label>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Pulsanti -->
    <div class="row mt-3">
      <div class="col text-end">
        <button class="btn btn-outline-secondary me-2" @click="resetFilters">
          <i class="bi bi-x"></i> Reset
        </button>
        <button class="btn btn-outline-primary" @click="applyAllFilters">
          <i class="bi bi-search"></i> Cerca
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allTopics: Array,
    allLegislations: Array,
    allArticles: Array,
    allRegions: Array,
    allYears: Array,
    isGestore: { type: Boolean, default: false },
    modelValueSelectedTopics: Array,
    modelValueSelectedLegislation: [Number, String, null],
    modelValueSelectedArticles: Array,
    questions: Array
  },
  emits: ['update:selectedTopics', 'update:selectedLegislation', 'update:selectedArticles', 'filter'],
  data() {
    return {
      localSelectedTopics: this.modelValueSelectedTopics || [],
      localSelectedLegislation: this.modelValueSelectedLegislation,
      localSelectedArticles: this.modelValueSelectedArticles || [],
      filterId: '',
      filterObject: '',
      filterOrganization: '',
      filterText: '',
      filterRegion: [],
      filterYear: [],
      topicSearch: '',
      articleSearch: '',
    };
  },
  computed: {
    selectedTopicsLabel() {
      const count = this.localSelectedTopics.length;
      if (count === 0) return 'Argomenti';
      if (count === 1) {
        const topic = this.allTopics.find(t => t.id === this.localSelectedTopics[0]);
        return topic ? topic.title : 'Argomenti';
      }
      return `Selezione multipla (${count})`;
    },
    selectedLegislationLabel() {
      const leg = this.allLegislations.find(l => l.id === this.localSelectedLegislation);
      return leg ? leg.title : 'Seleziona legislazione';
    },
    selectedArticlesLabel() {
      const count = this.localSelectedArticles.length;
      if (count === 0) return 'Articoli';
      if (count === 1) {
        const article = this.allArticles.find(a => a.id === this.localSelectedArticles[0]);
        return article ? article.title : 'Articoli';
      }
      return `Selezione multipla (${count})`;
    },
    selectedRegionsLabel() {
      const count = this.filterRegion.length;
      if (count === 0) return 'Regione';
      if (count === 1) {
        const region = this.allRegions.find(r => r.id === this.filterRegion[0]);
        return region ? region.name : 'Regione';
      }
      return `Selezione multipla (${count})`;
    },
    localSelectedYearLabel() {
      const count = this.filterYear.length;
      if (count === 0) return 'Anno';
      if (count === 1) return this.filterYear[0];
      return `Selezione multipla (${count})`;
    },
    fieldLabels() {
      return {
        filterId: 'ID Quesito',
        filterObject: 'Oggetto',
        filterOrganization: 'Stazione Appaltante',
        filterText: 'Testo Quesito'
      };
    },
    selectedLegislationLabel() {
      if (!this.localSelectedLegislation) return 'Tutte le legislazioni';
      const leg = this.allLegislations.find(l => l.id === this.localSelectedLegislation);
      return leg ? leg.title : 'Seleziona legislazione';
    },
    filteredTopics() {
      if (!this.topicSearch) return this.allTopics;
      return this.allTopics.filter(t =>
        t.title.toLowerCase().includes(this.topicSearch.toLowerCase())
      );
    },
    filteredArticles() {
      if (!this.articleSearch) return this.allArticles;
      return this.allArticles.filter(a =>
        a.title.toLowerCase().includes(this.articleSearch.toLowerCase())
      );
    },
  },
  methods: {
    applyAllFilters() {
      this.$emit('filter', {
        topics: this.localSelectedTopics,
        legislation: this.localSelectedLegislation,
        articles: this.localSelectedArticles,
        id: this.filterId,
        object: this.filterObject,
        organization: this.filterOrganization,
        text: this.filterText,
        region: this.filterRegion,
        year: this.filterYear
      });
    },
    resetFilters() {
      this.localSelectedTopics = [];
      this.localSelectedLegislation = null;
      this.localSelectedArticles = [];
      this.filterId = '';
      this.filterObject = '';
      this.filterOrganization = '';
      this.filterText = '';
      this.filterRegion = [];
      this.filterYear = [];
      this.$nextTick(() => {
        this.applyAllFilters();
      });
    }
  },
  watch: {
    localSelectedTopics(val) { this.$emit('update:selectedTopics', val); },
    localSelectedLegislation(val) { this.$emit('update:selectedLegislation', val); },
    localSelectedArticles(val) { this.$emit('update:selectedArticles', val); }
  }
};
</script>
<style scoped>
.truncate-text {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>
